import React, { useState, useEffect, useRef } from 'react';
import SpotifyWebApi from "spotify-web-api-js";  // I guess it is this: https://www.npmjs.com/package/spotify-web-api-node
import { useStateValue } from "./StateProvider";
import { onAuthStateChanged } from 'firebase/auth';
import { authV9 as auth } from "./firebase";
//import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// import Player from "./Player";
//import ChooseSong from "./ChooseSong";
import { getTokenFromResponse, storeToken, getStoredToken, getCodeFromResponse, getCodeVerifier, clearCodeVerifier, getClientId } from "./spotify";
import "./App.css";
import FirebaseAuth from "./Auth/FirebaseAuth";
import ConnectSpotify from "./Auth/ConnectSpotify";
import subscriptionManager from "./utils/subscriptionManager";
import { debugSubscription } from "./utils/debugSubscription";
// import ChoosePlaylist from "./ChoosePlaylist";
import ChooseSong from "./AddMySong/ChooseSong";
// import EnjoyTheCarousel from "./EnjoyTheCarousel";
import FeedbackCarousel from "./FeedbackCarousel/FeedbackCarousel";

// import SpotifyJam from "./SpotifyJam";
import RatingsOfMySong from "./MyRatings/RatingsOfMySong";
// import CheatMSG from "./CheatMSG";
import SpotifyPlayer from "./FeedbackCarousel/SpotifyPlayer";

import MeldungSongGeAdded from "./AddMySong/MeldungSongGeAdded";
import { NavBar } from "./responsive/navbar";
// import NoPlayerMSG from "./NoPlayerMSG";
import TagManager from 'react-gtm-module';
import ImprintDataPrivacyContact from "./FooterAndLinks/ImprintDataPrivacyContact";
// import FooterAutoplay from "./FooterAndLinks/FooterAutoplay";
import Footer from "./FooterAndLinks/Footer";

import { Routes, Route, Navigate } from "react-router-dom";
import FaqPage from "./FaqPage";
import SubscriptionModal from "./Subscription/SubscriptionModal";
import SubscriptionSuccess from "./Subscription/SubscriptionSuccess";
import BlogSongs from "./BlogSongs/BlogSongs";

const tagManagerArgs = {
  gtmId: 'GTM-T68K8MH'
}

TagManager.initialize(tagManagerArgs);

// Make debug tools available globally
if (typeof window !== 'undefined') {
  window.debugSubscription = debugSubscription;
  window.subscriptionManager = subscriptionManager;
}

//WANN IST READ DB WIEDER ERLAUBT, ANZAHL SEKUNDEN?
const timeUntilNoMoreChecks=120;




//FIREBASE STOPP

const s = new SpotifyWebApi();
//, menustate
function App() {      // beide nachher erlauben
  const [{ token, menustate, showSubscriptionModal, firebaseUser}, dispatch] = useStateValue();
 // const [{ token, menustate, dblesenerlauben, dblesencomingfrommenu, ratingdblesenerlauben, notokenmenuclick}, dispatch] = useStateValue();
  const [counter, setCounter] = useState(timeUntilNoMoreChecks);
  const [firebaseAuthChecked, setFirebaseAuthChecked] = useState(false);
  const [isExchangingToken, setIsExchangingToken] = useState(() => {
    // If returning from Spotify with a code in the URL, show loading immediately
    // This prevents the ConnectSpotify screen from flashing before the useEffect runs
    const params = new URLSearchParams(window.location.search);
    return !!params.get('code');
  });
  const [tokenExchangeError, setTokenExchangeError] = useState(null);
  const spotifyAuthInitialized = useRef(false);

  // Firebase Authentication Listener
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log('🔐 Firebase user authenticated:', user.email);
        // Store Firebase user in state
        dispatch({
          type: "SET_FIREBASEUSER",
          firebaseUser: user,
        });

        // Store email for subscription matching (from Firebase, not Spotify)
        dispatch({
          type: "SET_USEREMAIL",
          userEmail: user.email,
        });

        // Store Firebase UID for database operations
        dispatch({
          type: "SET_FIREBASEUID",
          firebaseUid: user.uid,
        });
      } else {
        console.log('🔐 No Firebase user authenticated');
        dispatch({
          type: "SET_FIREBASEUSER",
          firebaseUser: null,
        });
        dispatch({
          type: "SET_USEREMAIL",
          userEmail: null,
        });
        dispatch({
          type: "SET_FIREBASEUID",
          firebaseUid: null,
        });
        // Reset Spotify auth flag so it runs again when user logs back in
        spotifyAuthInitialized.current = false;
      }
      setFirebaseAuthChecked(true);
    });

    return () => unsubscribe();
  }, [dispatch]);

  useEffect(() => {
    // Only proceed with Spotify auth if Firebase user is authenticated
    if (!firebaseUser || !firebaseAuthChecked) {
      return;
    }

    const exchangeCodeForToken = async () => {
      // Check for authorization code (new PKCE flow)
      const code = getCodeFromResponse();

      if (code) {
        console.log('🔐 Authorization code received, exchanging for token...');
        setIsExchangingToken(true);
        setTokenExchangeError(null);

        const codeVerifier = getCodeVerifier();
        if (!codeVerifier) {
          console.error('No code verifier found in session storage');
          // Clear the code from URL to prevent repeated failed attempts
          const url = new URL(window.location.href);
          url.searchParams.delete('code');
          url.searchParams.delete('state');
          window.history.replaceState({}, document.title, url.pathname + url.hash);
          setTokenExchangeError('Connection session expired. Please try connecting again.');
          setIsExchangingToken(false);
          return null;
        }

        try {
          // Exchange code for token via Cloud Function
          const response = await fetch('https://us-central1-spot-feedback-carousel.cloudfunctions.net/spotifyTokenExchange', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              code: code,
              codeVerifier: codeVerifier,
              clientId: getClientId(),
              redirectUri: "https://songcarousel.com/",
            }),
          });

          if (!response.ok) {
            throw new Error('Token exchange failed');
          }

          const data = await response.json();

          // Clear the authorization code from URL
          const url = new URL(window.location.href);
          url.searchParams.delete('code');
          url.searchParams.delete('state');
          window.history.replaceState({}, document.title, url.pathname + url.hash);

          // Clear the code verifier
          clearCodeVerifier();

          console.log('✅ Successfully exchanged code for token');
          return data.access_token;
        } catch (error) {
          console.error('Error exchanging code for token:', error);
          // Clear the code from URL to prevent repeated failed attempts
          const url = new URL(window.location.href);
          url.searchParams.delete('code');
          url.searchParams.delete('state');
          window.history.replaceState({}, document.title, url.pathname + url.hash);
          clearCodeVerifier();
          setTokenExchangeError('Could not connect to Spotify. Please try again.');
          setIsExchangingToken(false);
          return null;
        }
      }

      // Check for token from URL hash (legacy implicit flow - for backward compatibility)
      const hash = getTokenFromResponse();
      let _token = hash.access_token;

      // Only clear hash if there was actually a token
      if (_token) {
        window.location.hash = "";
      }

      //FALLS MANUELL TOKEN:
      // let _token = "BQBpWjSZQ_YmZTKOYwfIE00Tda9WHOxEI6JGKmcjBrZyMs7-iqL278MziymR-juoB02IfnHfC2bIJoS0Vy0XUXXhj3LOBQOPg7V9I_WgUYSGeiRHV-nhTtt-cyV-wafhTqkcqVc-cPA_SOpo5wMOdID197fNHN6u8KiuqDqRfwLN3K8Qs_Q7uK5NxW0--vfL6bcXC6LUmRfe3yr_Yk_V-dDBSSdmBVo0lT5SwHPEMCjFLmeR5UQXXeh_ewwxSX73-sFxQZ0LIu2gnG8VZxvH6OotAR7Pmng_9mUTy56xUGdsmm9gugFT9lOeq4LB0_xPm9M9TenvxfY3gB9NEp_Is9g1wdjolGa9aRUaZ3ujCd_T"

      return _token;
    };

    const initializeSpotifyAuth = async () => {
      // Prevent re-running auth initialization if already done
      if (spotifyAuthInitialized.current) {
        console.log('🔄 Spotify auth already initialized, skipping...');
        return;
      }
      spotifyAuthInitialized.current = true;

      let _token = await exchangeCodeForToken();

      // If no token in URL, check localStorage
      if (!_token) {
        _token = getStoredToken();
        if (_token) {
          console.log('🔐 Restored token from localStorage');
        }
      } else {
        // New login - store token for persistence
        storeToken(_token);
        // Clear session storage on new login to ensure fresh song selection
        sessionStorage.removeItem('songCarouselSessionStart');
        // Clear ratings count for fresh start with new login
        localStorage.removeItem('countUserRatings');
        console.log('🔐 New Spotify login detected - storing token and clearing session');
      }

      if (_token) {
      s.setAccessToken(_token);

      dispatch({
        type: "SET_TOKEN",
        token: _token,
      });

      // Token is now set, stop showing exchange loading state
      setIsExchangingToken(false);

//für avatar
      dispatch({
        type: "SET_SPOTIFY",
        spotify: s,
      });
//für avatar
      s.getMe().then(async (spotifyUser) => {
        dispatch({
          type: "SET_USER",
          user: spotifyUser,
        });

        // Check subscription status based on Firebase email (not Spotify email)
        if (firebaseUser && firebaseUser.email) {
          console.log(`📧 Checking subscription for email: ${firebaseUser.email}`);

          const subscriptionConfig = await subscriptionManager.getSubscriptionConfig(firebaseUser.email);

          console.log(`🎫 Subscription check complete for ${firebaseUser.email}:`);
          console.log('   - Tier:', subscriptionConfig.tier);
          console.log('   - Status:', subscriptionConfig.subscriptionStatus);
          console.log('   - Listening time required:', subscriptionConfig.listeningTimeRequired, 'seconds');
          console.log('   - Max visible ratings:', subscriptionConfig.maxVisibleRatings);
          console.log('   - Songs to rate before upload:', subscriptionConfig.songsToRateBeforeUpload);

          dispatch({
            type: "SET_SUBSCRIPTIONCONFIG",
            subscriptionConfig: subscriptionConfig,
          });

          dispatch({
            type: "SET_USERTIER",
            userTier: subscriptionConfig.tier,
          });

          dispatch({
            type: "SET_SUBSCRIPTIONSTATUS",
            subscriptionStatus: subscriptionConfig.subscriptionStatus,
          });

          console.log(`✅ Subscription state updated for ${firebaseUser.email}`);

          // Subscribe to real-time subscription updates
          subscriptionManager.subscribeToStatusUpdates(firebaseUser.email, (tierData) => {
            console.log('🔄 Subscription status updated:', tierData);
            dispatch({
              type: "SET_SUBSCRIPTIONCONFIG",
              subscriptionConfig: tierData,
            });
            dispatch({
              type: "SET_USERTIER",
              userTier: tierData.tier,
            });
          });
        } else {
          console.warn('⚠️ No Firebase email found - defaulting to free tier');
        }
      });

      } else {
        // No token found - stop showing exchange loading state
        setIsExchangingToken(false);
      }
    };

    // Initialize Spotify authentication
    initializeSpotifyAuth();
  }, [dispatch, firebaseUser, firebaseAuthChecked]);


// COUNTER FÜR READ-BESCHRÄNKUNG START

// über reducer lesen erlaubt ja / nein

  // Bei jedem counter change
useEffect(() => {
  if (counter > 0) {
    const timer = setTimeout(() => setCounter(counter - 1), 1000);
    return () => clearTimeout(timer);
  }

  //COUNTER MENUSPERRE AKTIVIEREN (1 Sekunde früher)
  if (counter === 1) {
    dispatch({
      type: "SET_DBLESENCOMINGMENU",
      dblesencomingfrommenu:0,
    });
  }

  //COUNTER FÜR READ-BESCHRÄNKUNG ENDE
  if (counter === 0) {
    //Carousel
    dispatch({
      type: "SET_DBLESENJANEIN",
      dblesenerlauben:1,
    });

    //Rating Step 1
    dispatch({
      type: "SET_RATINGDBLESENJANEIN",
      ratingdblesenerlauben:1,
    });

    //wieder auf gesetzte Sekunden
    setCounter(timeUntilNoMoreChecks);
  }
}, [counter, dispatch]);

  // Listen for custom 'openSubscription' event from upgrade buttons
  useEffect(() => {
    const handleOpenSubscription = () => {
      dispatch({
        type: "SET_SHOWSUBSCRIPTIONMODAL",
        showSubscriptionModal: true,
      });
    };

    window.addEventListener('openSubscription', handleOpenSubscription);

    return () => {
      window.removeEventListener('openSubscription', handleOpenSubscription);
    };
  }, [dispatch]);

  // Function to close subscription modal
  const closeSubscriptionModal = () => {
    dispatch({
      type: "SET_SHOWSUBSCRIPTIONMODAL",
      showSubscriptionModal: false,
    });
  };

  // Auth state check - show appropriate screen
  if (!firebaseAuthChecked) {
    // Still checking Firebase auth state - show nothing or loading
    return <div className="app">Loading...</div>;
  }

  // Main app structure - available for all users (logged in or not)
  return (
    <div className="app">
      {/* Navigation is always visible */}
      <NavBar />

      {/* Global Spotify Player - only for logged-in users with Spotify token */}
      {firebaseUser && token && <SpotifyPlayer />}

      {/* React Router Routes */}
      <Routes>
        {/* Home/Carousel route */}
        <Route
          path="/"
          element={
            !firebaseUser ? (
              // Not logged into Firebase: Show auth screen
              <FirebaseAuth />
            ) : isExchangingToken ? (
              // Exchanging Spotify token: Show loading
              <div className="connect-spotify-minimal">
                <div className="connect-minimal-container" style={{textAlign: 'center', padding: '40px 20px'}}>
                  <p className="connect-minimal-description">Connecting to Spotify...</p>
                  <p style={{fontSize: '14px', color: '#b3b3b3', marginTop: '10px'}}>Please wait while we establish the connection.</p>
                </div>
              </div>
            ) : !token ? (
              // Logged into Firebase but no Spotify token: Show connect screen
              <>{tokenExchangeError && (
                <div style={{background: '#e74c3c', color: 'white', padding: '12px 20px', textAlign: 'center', fontSize: '14px'}}>
                  {tokenExchangeError}
                </div>
              )}
              <ConnectSpotify /></>
            ) : (
              // Fully logged in with Spotify: Show carousel based on menustate
              menustate === "addownsong" ? (
                <ChooseSong />
              ) : menustate === "songaddedtopool" ? (
                <MeldungSongGeAdded />
              ) : (
                <FeedbackCarousel spotify={s} />
              )
            )
          }
        />

        {/* Ratings page - always show RatingsOfMySong (handles auth internally) */}
        <Route
          path="/ratings-of-my-songs"
          element={<RatingsOfMySong spotify={s} />}
        />

        {/* FAQ page - always visible */}
        <Route path="/faq" element={<FaqPage />} />

        {/* Music Blog page - always visible */}
        <Route path="/music-blog" element={<BlogSongs />} />

        {/* Subscription success page */}
        <Route
          path="/subscription-success"
          element={
            !firebaseUser ? <FirebaseAuth /> : <SubscriptionSuccess />
          }
        />

        {/* Imprint/Privacy page - always visible */}
        <Route path="/imprint" element={<ImprintDataPrivacyContact />} />

        {/* Subscription cancel redirect */}
        <Route path="/subscription-cancel" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Footer - always visible */}
      <Footer />

      {/* Subscription Modal - Shows when upgrade buttons are clicked (only for logged-in users) */}
      {firebaseUser && token && (
        <SubscriptionModal
          isOpen={showSubscriptionModal}
          onClose={closeSubscriptionModal}
        />
      )}
    </div>
  );
  


}




export default App;
